import { z } from 'zod';
import { PAGE_SIZE_DEFAULT, PAGE_SIZE_MAX } from '../constants/app.js';
export const sortOrderSchema = z.enum(['asc', 'desc']);
/** `?sort=field:asc` — the field itself is validated per resource. */
export const sortParamSchema = z
    .string()
    .regex(/^[a-zA-Z][a-zA-Z0-9_.]*:(asc|desc)$/, 'Expected format "field:asc" or "field:desc"');
export const paginationQuerySchema = z.object({
    page: z.coerce.number().int().min(1).default(1),
    pageSize: z.coerce.number().int().min(1).max(PAGE_SIZE_MAX).default(PAGE_SIZE_DEFAULT),
    q: z.string().trim().min(1).max(200).optional(),
    sort: sortParamSchema.optional(),
});
export const paginationMetaSchema = z.object({
    page: z.number().int().min(1),
    pageSize: z.number().int().min(1),
    total: z.number().int().min(0),
    totalPages: z.number().int().min(0),
});
export function paginatedSchema(item) {
    return z.object({
        data: z.array(item),
        meta: paginationMetaSchema,
    });
}
export function buildPaginationMeta(input) {
    return {
        page: input.page,
        pageSize: input.pageSize,
        total: input.total,
        totalPages: input.pageSize > 0 ? Math.ceil(input.total / input.pageSize) : 0,
    };
}
//# sourceMappingURL=pagination.js.map